import moment from 'moment';
import { ConvertToRe, convertToDateObj, decryptChartData } from '../../utils/global_functions';
import { MULTIPLIER } from '../../utils/global_variables';


const convertHistoricData = (data = [], qty = 0) => {
    let arr = []
    for (let x of data) {
        let ltt = convertToDateObj(parseInt(x.nLastUpdatedDate));
        let lttvalue = parseInt(ltt.getTime().toString()) / MULTIPLIER.TEN_THOUSAND;
        let data = decryptChartData(x.sData);
        let splitData = data.split(',')
        let o = parseFloat(splitData[0]);
        let h = o + parseFloat(splitData[1]);
        let l = o - parseFloat(splitData[2]);
        let c = l + parseFloat(splitData[3]);
        let v = parseFloat(splitData[4]);
        let open = parseFloat(ConvertToRe(o, 1));
        let close = parseFloat(ConvertToRe(c, 1));
        let high = parseFloat(ConvertToRe(h, 1));
        let low = parseFloat(ConvertToRe(l, 1));
        let volume = v.toString();
        arr.push({ ltt, date: lttvalue, open: open, high: high, low: low, close: close, volume: parseInt(volume), qty })
    }
    return arr
}
const getNormalisation = (arr, name = "") => {
    let norm = [];
    let prevNorm = 1000
    let prev = 0
    let curr = 0
    let change = 0
    let perChange = 0
    if (name === 'portfolio') {
        prev = parseFloat(arr[0]?.finClose)
        arr.forEach((x, i) => {
            if (i + 1 === arr.length) return
            curr = parseFloat(arr[i + 1]?.finClose)
            change = curr - prev
            perChange = parseFloat(change.toFixed(2)) / prev
            prevNorm = prevNorm + (prevNorm * parseFloat(perChange.toFixed(2)))
            if (moment(x.ltt).format("MM") !== moment(arr[i + 1].ltt).format("MM")) {
                norm.push({ normPort: parseFloat(prevNorm.toFixed(2)), month: moment(x.ltt).format("MMM YY"), closePort: parseFloat(prev), ltt: x.date, date: moment(x.ltt).format("YYYY-MM-DD") })
            }
            prev = arr[i + 1].finClose

        })
    } else {
        prev = parseFloat(arr[0].close)
        arr.forEach((x, i) => {
            if (i + 1 === arr.length) return
            curr = parseFloat(arr[i + 1].close)
            change = curr - prev
            perChange = change / prev
            prevNorm = prevNorm + (prevNorm * perChange)
            if (moment(x.ltt).format("MM") !== moment(arr[i + 1].ltt).format("MM")) {
                norm.push({ normInd: parseFloat(prevNorm.toFixed(2)), month: moment(x.ltt).format("MMM YY"), closeInd: parseFloat(prev), ltt: x.date, date: moment(x.ltt).format("YYYY-MM-DD") })
            }
            prev = arr[i + 1].close
        })
    }
    return norm
}

const calculateMovingAverageSeriesData = (data, maLength) => {
    const maData = [];

    for (let i = 0; i < data.length; i++) {
        if (i < maLength) {
            // Provide whitespace data points until the MA can be calculated
            maData.push({ time: data[i].time });
        } else {
            // Calculate the moving average, slow but simple way
            let sum = 0;
            for (let j = 0; j < maLength; j++) {
                sum += data[i - j].close;
            }
            const maValue = sum / maLength;
            maData.push({ time: data[i].time, value: maValue });
        }
    }

    return maData;
};


export { convertHistoricData, getNormalisation, calculateMovingAverageSeriesData }